<template>
  <div id="views-page1">
    <!-- 头部 -->
    <HeaderTitle class="header-page" :title="title" :navIndex="3"></HeaderTitle>
    <!-- 内容 -->
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <!-- 智能脚环 -->
        <div class="left-one">
          <div class="title" style="padding-top: 10px">智能脚环</div>
          <footringVue
            style="width: 100%; height: 250px; margin-top: 20px"
          ></footringVue>
        </div>
        <!-- 智能料塔 -->
        <div class="left-two">
          <div class="title" style="padding-top: 10px">智能料塔</div>
          <tower style="width: 100%; height: 250px; margin-top: 20px"></tower>
        </div>
        <!-- 智能喂水 -->
        <div class="left-three">
          <div class="title" style="padding-top: 10px">智能喂水</div>
          <water style="width: 100%; height: 250px; margin-top: 20px"></water>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center">
        <!-- 监控视频 -->
        <div class="center-one">
          <div class="title" style="padding: 0 0 0 50px; margin-bottom: 12px">
            监控视频
          </div>
          <div @click="dialogVisible2 = true" class="center-one-duo">
            查看更多
          </div>
          <iframe
            :src="jiankUrl1"
            style="width: 100%; height: 540px"
            id="ysOpenDevice"
            ref="monitorVideo"
            allowfullscreen
          >
          </iframe>
          <i
            @click="fullscreen"
            style="
              position: absolute;
              bottom: 20px;
              right: 20px;
              font-size: 40px;
              z-index: 99;
              cursor: pointer;
            "
            class="el-icon-full-screen"
          ></i>
        </div>
        <!-- 智能控制 -->
        <div class="center-two">
          <div class="title" style="padding-left: 55px">智能控制</div>
          <div class="center-two-list">
            <div class="center-two-list-left">
              <div class="center-two-list-left-box">
                <img src="../../assets/device/fl.png" alt="" />
                <span>饲料阀</span>
                <span>{{ value == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange"
                >
                </el-switch>
              </div>

              <div class="center-two-list-left-box">
                <img src="../../assets/device/fengji.png" alt="" />
                <span>风机1</span>
                <span>{{ value3 == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value3"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange3"
                >
                </el-switch>
              </div>
              <div class="center-two-list-left-box">
                <img src="../../assets/device/fengji.png" alt="" />
                <span>风机2</span>
                <span>{{ value4 == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value4"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange4"
                >
                </el-switch>
              </div>
              <div class="center-two-list-left-box">
                <img src="../../assets/device/sl.png" alt="" />
                <span>水磊</span>
                <span>{{ value2 == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value2"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange2"
                >
                </el-switch>
              </div>
              <div class="center-two-list-left-box">
                <img src="../../assets/device/fengji.png" alt="" />
                <span>风机3</span>
                <span>{{ value5 == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value5"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange5"
                >
                </el-switch>
              </div>
              <div class="center-two-list-left-box">
                <img src="../../assets/device/fengji.png" alt="" />
                <span>风机4</span>
                <span>{{ value6 == true ? "开" : "关" }}</span>
                <el-switch
                  v-model="value6"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="switchChange6"
                >
                </el-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 右 -->
      <div class="right">
        <!-- 环境检测 -->
        <div class="right-one">
          <div class="title" style="padding-top: 10px">环境检测</div>
          <div class="right-one-list">
            <div
              class="right-one-list-item"
              v-for="(item, index) in hjList"
              :key="index"
            >
              <img :src="item.icon" alt="" />
              <div>
                <span>{{ item.name }}</span>
                <span style="color: #fff"
                  ><span
                    style="color: #03bcf8; font-size: 24px; font-weight: 600"
                    >{{ item.num }}</span
                  >{{ item.unit }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <!-- 智能预警 -->
        <div class="right-two">
          <div class="title" style="padding-top: 10px">智能预警</div>
          <div v-if="yujingShow" class="right-two-yujing">
            <i @click="yujingsolid" class="el-icon-message-solid"></i>
          </div>
          <div class="right-two-list">
            <div class="right-two-list-top">
              <div>设备名称</div>
              <div>预警信息信息</div>
              <div>时间</div>
            </div>
            <div class="right-two-list-bottom">
              <vue-seamless-scroll
                :class-option="classOptio"
                :data="listData"
                class="warp"
              >
                <div
                  style="cursor: pointer"
                  v-for="(item, index) in listData"
                  :key="index"
                  class="right-two-list-top"
                >
                  <div>{{ item.name }}</div>
                  <div style="color: #ff4949">{{ item.title }}</div>
                  <div>{{ item.time }}</div>
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 预警提升框 -->
    <div class="yujingdialog">
      <el-dialog
        title="今日预警信息"
        :visible.sync="dialogVisible"
        width="40%"
        :modal-append-to-body="false"
      >
        <div style="color: #fff; font-size: 18px; letter-spacing: 2px">
          今日鸡舍一的料塔剩余5%，请及时添加饲料！
        </div>
        <el-button
          @click="closeDialog"
          style="margin: 50px auto 0; display: block"
          type="primary"
          >我知道了</el-button
        >
      </el-dialog>
    </div>
    <!-- 监控视频弹出框 -->
    <div class="jiankdialog">
      <el-dialog
        title="今日预警信息"
        :visible.sync="dialogVisible2"
        width="70%"
        :modal-append-to-body="false"
      >
        <div style="display: flex">
          <div class="dialog-list">
            <div style="display: flex; flex-direction: column; height: 550px">
              <span
                :class="jkIndex == index ? 'dialog-itemys' : 'dialog-item'"
                @click="tojk(index)"
                v-for="(item, index) in jianList.slice(
                  jianListNum,
                  jianListNums
                )"
                :key="index"
                >{{ item.name }}</span
              >
            </div>
            <el-pagination
              v-if="jianList.length > 9"
              @current-change="handleCurrentChange"
              background
              layout="total,prev, pager, next"
              :total="jianList.length"
            >
            </el-pagination>
          </div>
          <div>
            <iframe
              :src="jiankurl"
              style="width: 800px; height: 540px"
              id="ysOpenDevice"
              ref="monitorVideo2"
              allowfullscreen
            >
            </iframe>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-around;
              "
              class="cqdeat"
            >
              <!-- 智能控制 -->
              <el-button
                @click="getKz(2)"
                type="primary"
                icon="el-icon-caret-left"
              ></el-button>
              <el-button
                @click="getKz(0)"
                type="primary"
                icon="el-icon-caret-top"
              ></el-button>
              <el-button
                @click="getKz(1)"
                type="primary"
                icon="el-icon-caret-bottom"
              ></el-button>
              <el-button
                @click="getKz(3)"
                type="primary"
                icon="el-icon-caret-right"
              ></el-button>
              <el-button
                @click="getKz(8)"
                type="primary"
                icon="el-icon-zoom-in"
              ></el-button>
              <el-button
                @click="getKz(9)"
                type="primary"
                icon="el-icon-zoom-out"
              ></el-button>
              <!-- 全屏按钮 -->
              <i
                @click="iframedx2"
                style="cursor: pointer; font-size: 55px"
                class="el-icon-full-screen"
              ></i>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// 引入鸡脚环的数据
import footringVue from "../../components/device/footring.vue";
// 引入智能料塔
import tower from "../../components/device/tower.vue";
// 引入智能喂水
import water from "../../components/device/water.vue";
// 引入头部
import HeaderTitle from "../../components/HeaderTitle.vue";
import axios from "axios";
export default {
  components: {
    HeaderTitle,
    footringVue,
    tower,
    water,
  },
  data: function () {
    return {
      title: "智能设备数据监测分析一张图",
      jiankUrl1:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9886941/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      jiankUrl2:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887033/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      jiankUrl3:
        "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887101/1.hd.live&autoplay=1&accessToken=at.8d4p653o7ukfofjhdmfu6tqt7k6v91oq-969nbvbp10-0w9muta-bkuh9va9y&AppKey=248cd3b6278e41be94df07500e0a912d",
      value: true,
      value2: false,
      value3: true,
      value4: false,
      value5: true,
      value6: false,
      hjList: [
        {
          name: "温度",
          num: "32",
          unit: "℃",
          icon: require("../../assets/device/wendu.png"),
        },
        {
          name: "湿度",
          num: "60",
          unit: "%",
          icon: require("../../assets/device/daqishidu.png"),
        },
        {
          name: "氨气浓度",
          num: "30",
          unit: "%",
          icon: require("../../assets/device/turangshidu.png"),
        },
        {
          name: "二氧化碳",
          num: "500",
          unit: "CO2",
          icon: require("../../assets/device/eryanghuatan.png"),
        },
        {
          name: "光照轻度",
          num: "1400",
          unit: "LUX",
          icon: require("../../assets/device/guangzhaoqiangdu.png"),
        },
        {
          name: "空气流通",
          num: "5",
          unit: "m/s",
          icon: require("../../assets/device/turangwendu.png"),
        },
      ],
      listData: [
        {
          name: "鸡舍二",
          title: "温度过高",
          time: "2024/7/18 17:45",
        },
        {
          name: "料塔三",
          title: "饲料太少预警",
          time: "2024/7/17 9:45",
        },
        {
          name: "智能喂水机",
          title: "水量太少预警",
          time: "2024/7/17 10:45",
        },
        {
          name: "料塔一",
          title: "饲料太少预警",
          time: "2024/7/16 12:45",
        },
        {
          name: "鸡舍二",
          title: "温度过高",
          time: "2024/7/18 17:45",
        },
        {
          name: "料塔三",
          title: "饲料太少预警",
          time: "2024/7/17 9:45",
        },
        {
          name: "智能喂水机",
          title: "水量太少预警",
          time: "2024/7/17 10:45",
        },
        {
          name: "料塔一",
          title: "饲料太少预警",
          time: "2024/7/16 12:45",
        },
        {
          name: "鸡舍二",
          title: "温度过高",
          time: "2024/7/18 17:45",
        },
        {
          name: "料塔三",
          title: "饲料太少预警",
          time: "2024/7/17 9:45",
        },
        {
          name: "智能喂水机",
          title: "水量太少预警",
          time: "2024/7/17 10:45",
        },
        {
          name: "料塔一",
          title: "饲料太少预警",
          time: "2024/7/16 12:45",
        },
      ],
      classOptio: {
        step: 0.5,
      },
      dialogVisible: false,
      dialogVisible2: false,
      jianList: [
        {
          name: "美绿思生态农牧科技馆陶有限公司",
          icon: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9886941/1.hd.live&autoplay=1&accessToken=at.6g2m87ys4e9hkz3h0osjlvklaslowa8a-4jnzzn2vjq-0u4gd64-n6j0vcbhr&AppKey=248cd3b6278e41be94df07500e0a912d",
        },
        {
          name: "馆陶县佳凤蛋鸡养殖专业合作社",
          icon: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887033/1.hd.live&autoplay=1&accessToken=at.6g2m87ys4e9hkz3h0osjlvklaslowa8a-4jnzzn2vjq-0u4gd64-n6j0vcbhr&AppKey=248cd3b6278e41be94df07500e0a912d",
        },
        {
          name: "馆陶县百谷源养殖有限公司",
          icon: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AE9887101/1.hd.live&autoplay=1&accessToken=at.6g2m87ys4e9hkz3h0osjlvklaslowa8a-4jnzzn2vjq-0u4gd64-n6j0vcbhr&AppKey=248cd3b6278e41be94df07500e0a912d",
        },
      ],
      jianListNum: 0,
      jianListNums: 9,
      jkIndex: 0,
      jiankurl: "",
      yujingShow: true,
    };
  },
  created() {
    this.tojk(this.jkIndex);
  },
  mounted() {
    // this.getPhone();
    // this.getVadio();
  },
  methods: {
    // 全屏
    fullscreen() {
      const monitorVideo = this.$refs.monitorVideo;
      if (monitorVideo.requestFullscreen) {
        monitorVideo.requestFullscreen();
      } else if (monitorVideo.mozRequestFullScreen) {
        /* Firefox */
        monitorVideo.mozRequestFullScreen();
      } else if (monitorVideo.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        monitorVideo.webkitRequestFullscreen();
      } else if (monitorVideo.msRequestFullscreen) {
        /* IE/Edge */
        monitorVideo.msRequestFullscreen();
      }
    },
    iframedx2() {
      const monitorVideo = this.$refs.monitorVideo2;
      if (monitorVideo.requestFullscreen) {
        monitorVideo.requestFullscreen();
      } else if (monitorVideo.mozRequestFullScreen) {
        /* Firefox */
        monitorVideo.mozRequestFullScreen();
      } else if (monitorVideo.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        monitorVideo.webkitRequestFullscreen();
      } else if (monitorVideo.msRequestFullscreen) {
        /* IE/Edge */
        monitorVideo.msRequestFullscreen();
      }
    },
    // 切换监控
    tojk(index) {
      this.jkIndex = index;
      this.jiankurl = this.jianList[index].icon;
    },
    // 饲料控制
    switchChange(value) {
      if (value == true) {
        this.$notify({
          title: "饲料阀打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "饲料阀关闭",
          type: "success",
        });
      }
    },
    // 水磊控制
    switchChange2(value) {
      if (value == true) {
        this.$notify({
          title: "水磊打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "水磊关闭",
          type: "success",
        });
      }
    },
    // 风机控制
    switchChange3(value) {
      if (value == true) {
        this.$notify({
          title: "风机1打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "风机1关闭",
          type: "success",
        });
      }
    },
    // 风机控制
    switchChange4(value) {
      if (value == true) {
        this.$notify({
          title: "风机2打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "风机2关闭",
          type: "success",
        });
      }
    },
    // 风机控制
    switchChange5(value) {
      if (value == true) {
        this.$notify({
          title: "风机3打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "风机3关闭",
          type: "success",
        });
      }
    },
    // 风机控制
    switchChange6(value) {
      if (value == true) {
        this.$notify({
          title: "风机4打开",
          type: "success",
        });
      } else if (value == false) {
        this.$notify({
          title: "风机4关闭",
          type: "success",
        });
      }
    },
    // 监控控制
    getKz(index) {
      let message;
      switch (index) {
        case 0:
          message = "监控向上移动";
          break;
        case 1:
          message = "监控向下移动";
          break;
        case 2:
          message = "监控向左移动";
          break;
        case 3:
          message = "监控向右移动";
          break;
        case 8:
          message = "监控放大";
          break;
        case 9:
          message = "监控缩小";
          break;
        default:
          break;
      }
      this.$notify({
        title: message,
        type: "success",
      });
    },
    // 预警信息
    yujingsolid() {
      this.dialogVisible = true;
    },
    // 关闭预警信息
    closeDialog() {
      this.dialogVisible = false;
      this.yujingShow = false;
    },
    // 获取监控ak
    getPhone() {
      axios({
        method: "get",
        url: "http://43.137.43.240:19012/prod-api/system/phone/gettoken/18832005872",
      }).then((res) => {
        this.ak = res.data.msg;
      });
    },
    // 获取监控
    getVadio() {
      axios({
        method: "get",
        url: "http://43.137.43.240:19012/prod-api/system/shipin/openapi/sellectuidshipinpage",
      }).then((res) => {
        console.log("获取监控", res);
      });
    },
    // 分页
    handleCurrentChange(num) {
      // console.log("当前页数", num);
      this.jianListNum = num * 9 - 9;
      this.jianListNums = num * 9;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .cqdeat .el-button {
  font-size: 25px;
}
.dialog-list {
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-left: 30px;
  .dialog-item {
    width: 250px;
    padding: 10px;
    background-color: #094e9280;
    border-radius: 10px;
    margin-bottom: 20px;
    color: #fff;
    cursor: pointer;
    &:hover {
      background-color: #36afffaf;
    }
  }
  .dialog-itemys {
    width: 250px;
    padding: 10px;
    background-color: #36afffaf;
    border-radius: 10px;
    margin-bottom: 20px;
    color: #fff;
    cursor: pointer;
  }
}

::v-deep .el-switch__core {
  width: 60px !important;
  height: 30px !important;
  border-radius: 20px;
}
::v-deep .el-switch__core:after {
  top: 6px;
}
::v-deep .yujingdialog .el-dialog {
  background-image: url("../../assets/device/tck.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 10vh !important;
  background-color: rgba(204, 204, 204, 0) !important;
  padding: 50px;
}
::v-deep .yujingdialog .el-dialog__header {
  text-align: center;
}
::v-deep .yujingdialog .el-dialog__headerbtn {
  top: 45px;
  right: 60px;
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  border-radius: 50%;
}
::v-deep .yujingdialog .el-dialog__close {
  color: #fff;
  font-size: 25px;
}
::v-deep .yujingdialog .el-dialog__headerbtn:hover {
  border: 2px solid red;
}
::v-deep .yujingdialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: red;
}
::v-deep .yujingdialog .el-dialog__close:hover {
  color: red;
}
::v-deep .yujingdialog .el-dialog__title {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 2px;
}
::v-deep .jiankdialog .el-dialog {
  background-color: #1a2042 !important;
  background-image: url("../../assets/cockpit/center.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 10vh !important;
}
::v-deep .jiankdialog .el-dialog__title {
  color: #fff !important;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 2px;
}
</style>
<style lang="scss" scoped>
#views-page1 {
  box-sizing: border-box;
  background: url(~@/assets/background-img.png) no-repeat center center;
  background-size: 100% 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}
// 内容
.content {
  color: #fff;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // 左
  .left {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 智能脚环
    .left-one {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 智能料塔
    .left-two {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 智能喂水
    .left-three {
      width: 100%;
      height: 32%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  // 中间
  .center {
    width: 42%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 监控视频
    .center-one {
      width: 100%;
      height: 60%;
      background-image: url("../../assets/price/zhongjiankuang.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .center-one-duo {
        position: absolute;
        right: 10px;
        top: 0px;
        height: 35px;
        font-size: 18px;
        text-align: center;
        cursor: pointer;
        line-height: 35px;
        width: 120px;
        background-image: url("../../assets/cockpit/duo.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
    }
    // 智能控制
    .center-two {
      width: 100%;
      height: 37%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .center-two-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80%;
        margin-top: 30px;
        width: 100%;
        .center-two-list-left {
          margin: 20px auto;
          width: 96%;
          height: 90%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .center-two-list-left-box {
            width: 30%;
            height: 90px;
            box-shadow: 0 0 5px 0 #6fc3df;
            display: flex;
            align-items: center;
            justify-content: space-around;
            &:hover {
              background-color: #5585a8;
            }
            img {
              width: 50px;
              height: 50px;
            }
            span {
              font-size: 20px;
              font-weight: 600;
            }
          }
        }
        // .center-two-list-right {
        //   width: 60%;
        //   text-align: center;
        //   display: flex;
        //   flex-direction: column;
        //   align-items: center;
        //   .center-two-list-right-bottom {
        //     display: flex;
        //     align-items: center;
        //   }
        //   .center-two-list-right-anniu {
        //     width: 80px;
        //     height: 80px;
        //     text-align: center;
        //     line-height: 80px;
        //     border-radius: 10px;
        //     background-color: #2299e3;
        //     font-size: 50px;
        //     cursor: pointer;

        //     &:hover {
        //       background-color: #009dff;
        //     }
        //   }
        // }
      }
    }
  }
  // 右
  .right {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // 环境检测
    .right-one {
      width: 100%;
      height: 34%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .right-one-list {
        width: 100%;
        margin: 20px auto 0;
        height: 80%;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        .right-one-list-item {
          margin-bottom: 10px;
          width: 33%;
          height: 110px;
          background-image: url("../../assets/device/kuang.png");
          background-size: 100% 100%;
          background-repeat: no-repeat;
          display: flex;
          align-items: center;
          justify-content: space-around;
          div {
            font-size: 16px;
            letter-spacing: 2px;
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
    // 智能预警
    .right-two {
      width: 100%;
      height: 63%;
      background-image: url("../../assets/cockpit/back-4.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .right-two-yujing {
        position: absolute;
        right: 20px;
        top: 5px;
        font-size: 30px;
        animation: blink 1s infinite;
        cursor: pointer;
      }
      @keyframes blink {
        0% {
          color: red;
        }
        50% {
          color: #fff;
        }
        100% {
          color: red;
        }
      }
      .right-two-list {
        margin: 20px auto;
        width: 98%;
        height: 89%;
        .right-two-list-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 40px;
          line-height: 40px;
          border: 1px solid #009dff;
          font-size: 18px;
          letter-spacing: 2px;
          div {
            width: 33%;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .right-two-list-bottom {
          width: 100%;
          height: 500px;
          overflow: hidden;
          .warp {
            width: 100%;
            height: 500px;
            overflow: hidden;
          }
        }
      }
    }
  }
}
// 模块名称
.title {
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #a3dcff);
  -webkit-background-clip: text !important;
  background-clip: text;
  color: transparent;
  padding: 13px 0 0 40px;
}
</style>
